import { useEffect } from "react";

const useScrollToTop = (deps = []) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, deps);
};

export default useScrollToTop;
